import UIkit from 'uikit/dist/js/uikit-core';

/**
 * Uncomment to use UIkit Icons
 * @see https://getuikit.com/docs/icon
 */
// import Icons from 'uikit/dist/js/uikit-icons';
// UIkit.use(Icons);

// import Countdown from 'uikit/src/js/components/countdown';
// UIkit.component('countdown', Countdown);

// import Filter from 'uikit/src/js/components/filter';
// UIkit.component('filter', Filter);

import Lightbox from 'uikit/src/js/components/lightbox';
UIkit.component('lightbox', Lightbox);

// import lightboxPanel from 'uikit/src/js/components/lightbox-panel';
// UIkit.component('lightboxPanel', lightboxPanel);

import Notification from 'uikit/src/js/components/notification';
UIkit.component('notification', Notification);

/* import Parallax from 'uikit/src/js/components/parallax';
UIkit.component('parallax', Parallax); */

/* import Slider from 'uikit/src/js/components/slider';
UIkit.component('slider', Slider); */

// import SliderParallax from 'uikit/src/js/components/slider-parallax';
// UIkit.component('sliderParallax', SliderParallax);
// UIkit.component('slideshowParallax', SliderParallax);

/* import Slideshow from 'uikit/src/js/components/slideshow';
UIkit.component('slideshow', Slideshow); */

// import Sortable from 'uikit/src/js/components/sortable';
// UIkit.component('sortable', Sortable);

import Tooltip from 'uikit/src/js/components/tooltip';
UIkit.component('tooltip', Tooltip);

// import Upload from 'uikit/src/js/components/upload';
// UIkit.component('upload', Upload);

export default UIkit;



// WEBPACK FOOTER //
// ./public/themes/frontend/mtg/assets/js/components.js